export const generatedCategories = [
  {
    "id": "Music",
    "name": "Music",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/BestOf90sHindi_20251125041813_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Live Events",
    "name": "Live Events",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/logo/YouOnlyLiveOnce_20201217181925_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Made For You",
    "name": "Made For You",
    "icons": [
      {
        "url": "https://images.unsplash.com/photo-1614680376593-902f74cf0d41?w=274&h=274&fit=crop",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "New Releases",
    "name": "New Releases",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/TaazaTunes_20260601104008_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Summer",
    "name": "Summer",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/SummerRomanceBhojpuri_20260511091020_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Hindi",
    "name": "Hindi",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/charts_Hindi1990s_136920_20240408061858_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Tamil",
    "name": "Tamil",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/charts_Tamil1990s_190250_20240408062124_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Pop",
    "name": "Pop",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/BestOfIndipopHindi_20260504065326_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Charts",
    "name": "Charts",
    "icons": [
      {
        "url": "https://pli.saavncdn.com/76/81/81787681_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Podcast Charts",
    "name": "Podcast Charts",
    "icons": [
      {
        "url": "https://pli.saavncdn.com/76/81/81787681_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Podcast New Releases",
    "name": "Podcast New Releases",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/TaazaTunes_20260601104008_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Punjabi",
    "name": "Punjabi",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/PunjabiHitSongs_20260409070056_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Telugu",
    "name": "Telugu",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/charts_Telugu1990s_157621_20240408063237_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Malayalam",
    "name": "Malayalam",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/charts_Malayalam1990s_170434_20240408063530_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Haryanvi",
    "name": "Haryanvi",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/Haryanvi-IndiaSuperhitsTop50_20260605060447_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Discover",
    "name": "Discover",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/DiscoveringMe_20231208143930_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Bhojpuri",
    "name": "Bhojpuri",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/BhojpuriViralHits_20260610102957_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Ghazals",
    "name": "Ghazals",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/BestOfGhazalsHindi_20260325065302_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Indie",
    "name": "Indie",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/BestOfIndieHindi_20260617091926_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Love",
    "name": "Love",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/MostStreamedLoveSongs-Hindi_20260302042416_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Trending",
    "name": "Trending",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/NowTrending_20260423085344_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Mood",
    "name": "Mood",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/MonsoonMoodsCarvaanSelect_20250625162244_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Party",
    "name": "Party",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/BestOfDanceHindi_20260617045802_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Devotional",
    "name": "Devotional",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/Hanuman_20260401062920_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Hip-Hop",
    "name": "Hip-Hop",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/Let_sPlayEmiwayBantai_20240517065551_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Dance/Electronic",
    "name": "Dance/Electronic",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/BestOfDanceHindi_20260617045802_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Chill",
    "name": "Chill",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/ChillMaaro-LoFiMix_20260403095103_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Gaming",
    "name": "Gaming",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/logo/MonstercatGaming_20190604084018_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "K-pop",
    "name": "K-pop",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/BestofKPop_20260615095904_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Workout Music",
    "name": "Workout Music",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/BollywoodRockWorkoutMix_20240229050234_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "RADAR",
    "name": "RADAR",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/UnderTheRadarPop_20260605113945_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Fresh Finds",
    "name": "Fresh Finds",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/TaazaTunes_20260601104008_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Rock",
    "name": "Rock",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/BollywoodRockWorkoutMix_20240229050234_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Sleep",
    "name": "Sleep",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/SoundSleep_20250728122503_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Indian Classical",
    "name": "Indian Classical",
    "icons": [
      {
        "url": "https://images.unsplash.com/photo-1605518216938-7c31b7b14ad0?w=274&h=274&fit=crop",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Instrumental",
    "name": "Instrumental",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/TakatakThemeMusic_20260403095201_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "At Home",
    "name": "At Home",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/ChillatHomeTamil_20260309093259_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Country",
    "name": "Country",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/BestofClassicCountryEnglish_20251209111008_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "R&B",
    "name": "R&B",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/Let_sPlayBPraakHindi_20251127090700_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Metal",
    "name": "Metal",
    "icons": [
      {
        "url": "https://images.unsplash.com/photo-1598387993281-cecf8b71a8f8?w=274&h=274&fit=crop",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Jazz",
    "name": "Jazz",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/DesiJazz_20250404045524_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Classical",
    "name": "Classical",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/logo/ClassicalAmbience_99978528_20170915_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Folk & Acoustic",
    "name": "Folk & Acoustic",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/artist_selects-1039520512_20220317082925_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Focus",
    "name": "Focus",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/TotalFocus_20250902051509_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Soul",
    "name": "Soul",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/SoulStringsbyArchit_20260528090012_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Kids & Family",
    "name": "Kids & Family",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/FamilyValues-TimelessMelodies_20250220095128_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Anime",
    "name": "Anime",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/AnimeHits_20250219095901_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "TV & Movies",
    "name": "TV & Movies",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/DecadeOfHeroes1990s_20240903100210_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Punk",
    "name": "Punk",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/Let_sPlayDaftPunk_20240729065553_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Ambient",
    "name": "Ambient",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/YOGAasana_20250318053935_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Blues",
    "name": "Blues",
    "icons": [
      {
        "url": "https://images.unsplash.com/photo-1525926477800-7a3eaaefbfeb?w=274&h=274&fit=crop",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Cooking & Dining",
    "name": "Cooking & Dining",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/logo/CookingKaroNaGroovyMix_20200319161252_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Alternative",
    "name": "Alternative",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/Decadeof2010sAlternativeEnglish_20240722104508_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Travel",
    "name": "Travel",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/RoadTrip_20260617050110_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Afro",
    "name": "Afro",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/BestofAfrobeat_20251223111033_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Funk & Disco",
    "name": "Funk & Disco",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/Let_sPlayMithunChakraborty_20240229050229_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Music + Talk",
    "name": "Music + Talk",
    "icons": [
      {
        "url": "https://c.saavncdn.com/editorial/Let_sPlayModernTalking_20251028072923_500x500.jpg",
        "width": 274,
        "height": 274
      }
    ]
  },
  {
    "id": "Latin",
    "name": "Latin",
    "icons": [
      {
        "url": "https://images.unsplash.com/photo-1533174000273-e18e87859d05?w=274&h=274&fit=crop",
        "width": 274,
        "height": 274
      }
    ]
  }
];
